var map = {
	"./ballvalve.webp": 7340,
	"./cryogenic.webp": 8812,
	"./flanges.png": 103,
	"./globevalve.webp": 8006,
	"./injquills.webp": 7336,
	"./manifold.png": 85,
	"./needle.webp": 9236,
	"./relief.webp": 9170,
	"./sealant_injection_fittings.webp": 2510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4439;